import { TopNav } from "./TopNav";
import * as React from "react";
import { Outlet, useLocation, useNavigation } from "react-router-dom";
import { AccountHolder } from "./Account";
import { RequestsView } from "@tlc/ls2pac/app/views/RequestsView";
import { BT_EResourceRequestView } from "@tlc/ls2pac/app/views/BT_EResourceRequestView";
import { removeCookie } from "typescript-cookie";
import { VirtualShelfView } from "@tlc/ls2pac/app/views/VirtualShelfView";
import { VirtualShelfControl } from "@tlc/ls2pac/app/controls/VirtualShelfController";
import { LinearProgress } from "@mui/material";
import { useEffect, useRef } from "react";
import { useLocationConfiguration } from "./LocationConfiguration";
import { skipLinkRegistry } from "../hooks/skipLinkRegistry";
import VirtualShelfDialog from "./pages/account/VirtualShelfDialog";

export async function rootLoader() {
  return await AccountHolder.fetchAccountData();
}

export const Root: React.FC = () => {
  const location = useLocation();
  const navigation = useNavigation();

  const showSearchForm =
    location.pathname === "/" ||
    location.pathname === "/search" ||
    location.pathname.indexOf("section") !== -1;

  React.useEffect(() => {
    // TODO is this handled in AuthContext already?
    removeCookie("SAVED_DESTINATION"); // remove SAVED_DESTINATION on page load
    RequestsView.init();
    new BT_EResourceRequestView();
    new VirtualShelfControl();
    // new VirtualShelfView();
    return () => {};
  }, []);

  const loading = navigation.state === "loading";

  return (
    <>
      {/* holds space when not loading so there is no layout jump */}
      <LinearProgress
        aria-label="Loading"
        variant={loading ? "indeterminate" : "determinate"}
        value={100}
      />
      <TopNav showSearchForm={showSearchForm}></TopNav>
      <Outlet></Outlet>
    </>
  );
};
